/** Tips cache + loader — replaces the static TIPS_DECK import. */
import { api } from "./api";
import { lsGet, lsSet } from "./safeStorage";
const CACHE_KEY = "habano.tips.cache";

export function readTipsCache() {
  try { const raw = lsGet(CACHE_KEY); return raw ? JSON.parse(raw) : null; } catch { return null; }
}
export function writeTipsCache(rows) {
  try { lsSet(CACHE_KEY, JSON.stringify(rows || [])); } catch { /* ignore */ }
}

export async function loadTips() {
  try {
    const { data } = await api.get("/tips");
    writeTipsCache(data || []);
    return data || [];
  } catch {
    return readTipsCache() || [];
  }
}

export function pickLang(field, lang) {
  if (!field) return "";
  if (typeof field === "string") return field;
  return field[lang] || field.en || field.es || "";
}
